import type { SxProps } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { type DropdownItem, SystemDropdown } from "@/ui/Inputs/SystemDropDown";
import { TEAM_SECTIONS } from "./config";

const CONTRACT_SECTIONS_DROPDOWN_WIDTH = "200px";

type ContractSectionsDropdownProps = {
	selectedSections: ReadonlySet<string> | readonly string[];
	onChange: (sections: string[]) => void;
	dataTestId: string;
	overrideSelectSx?: SxProps;
};

/**
 * Shared Contract Type dropdown used across Team, Weekly Gaps, Daily Standard,
 * and Daily Gaps. Centralizes the TEAM_SECTIONS → DropdownItem mapping and
 * dropdown width so the filter looks identical everywhere.
 */
export const ContractSectionsDropdown: FC<ContractSectionsDropdownProps> = ({ selectedSections, onChange, dataTestId, overrideSelectSx }) => {
	const { t } = useTranslation();
	const selectedItems = Array.isArray(selectedSections) ? selectedSections : Array.from(selectedSections);

	return (
		<SystemDropdown
			data-testid={dataTestId}
			items={TEAM_SECTIONS.map<DropdownItem<string>>((section) => ({
				label: section.title,
				value: section.title,
				id: section.title,
			}))}
			onChangeMultiple={onChange}
			selectedItems={selectedItems}
			multiple
			label={t("contract.type")}
			selectSx={{ width: CONTRACT_SECTIONS_DROPDOWN_WIDTH, ...overrideSelectSx }}
		/>
	);
};
